var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpacesModalHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5419_7437)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2,
    width: 32,
    height: 32,
    rx: 3.47841,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2.5,
    width: 31,
    height: 31,
    rx: 2.97841,
    stroke: "url(#paint0_linear_5419_7437)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5419_7437)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 10V13H28.5C29.0523 13 29.5 13.4477 29.5 14V24C29.5 25.6569 28.1569 27 26.5 27H24.5H12.5C10.8431 27 9.5 25.6569 9.5 24V10C9.5 9.44772 9.94772 9 10.5 9H24.5C25.0523 9 25.5 9.44772 25.5 10ZM27.5 24C27.5 24.5523 27.0523 25 26.5 25C25.9477 25 25.5 24.5523 25.5 24V15H27.5V24ZM13.5 14C13.5 13.4477 13.9477 13 14.5 13H20.5C21.0523 13 21.5 13.4477 21.5 14C21.5 14.5523 21.0523 15 20.5 15H14.5C13.9477 15 13.5 14.5523 13.5 14ZM15.5 18C15.5 17.4477 15.9477 17 16.5 17H20.5C21.0523 17 21.5 17.4477 21.5 18C21.5 18.5523 21.0523 19 20.5 19H16.5C15.9477 19 15.5 18.5523 15.5 18Z",
    fill: "url(#paint1_linear_5419_7437)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5419_7437",
    x: 0.891195,
    y: 0.260796,
    width: 37.2176,
    height: 37.2176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.869602
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3044
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5419_7437"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5419_7437",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5419_7437",
    x1: 3.95977,
    y1: 28.0945,
    x2: 35.5,
    y2: 28.0945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5419_7437",
    x1: 9.78736,
    y1: 23.6781,
    x2: 29.5,
    y2: 23.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5419_7437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(7.5 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacesModalHeaderIcon);
export default __webpack_public_path__ + "static/media/spacesModalHeaderIcon.3a716887fd60ea7e8216904784194cc7.svg";
export { ForwardRef as ReactComponent };